<template>
  <div>
    <vxe-grid
      size="small"
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.table_label_action') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:riskCheckStatus="{ row }">
        <el-tag :type="row.riskCheckStatus === 'N' ? 'info' : ''" size="mini">
          {{ row.v_riskCheckStatus }}
        </el-tag>
      </template>
      <template v-slot:riskLevel="{ row }">
        <el-tag
          v-if="row.v_riskLevel"
          size="mini"
          :type="
            row.riskLevel === 'normal'
              ? 'success'
              : row.riskLevel === 'lowRisk'
              ? 'warning'
              : 'danger'
          "
        >
          {{ row.v_riskLevel }}
        </el-tag>
      </template>

      <template v-slot:displayRiskCheckBy="{ row }">
        <span>{{ row.riskCheckByName }}</span>
        <br />
        <span>{{ row.riskCheckDate }}</span>
      </template>
      <template v-slot:displayCreateBy="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModifyBy="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditDialog', { type: menuType, data })
          break
        case 'submit':
          this.submit(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async submit({ riskCheckCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_submit') || '确认要提交本次风险核查结果吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const res = await this.$api
        .customerRiskCheckSubmitApi({ riskCheckCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.tips_submission_failed') || '提交失败！'
        )
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功!',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
